const func = ($target) => {
    var $plLength = $("body").find(`[data-kd-id='product-list']`).length;
    if ($plLength > 0) {
        $('body').removeClass('product-list-category-footer').addClass('product-list-category-footer');
    }
    var $headerBasket = $('[data-target="#basket-slideout"]'),
        $cartUpdate = $('[data-id="cart-update-toggle"]'),
        $loader = '<span class = "mr-1 spinner-border spinner-border-sm" role = "status" aria-hidden = "true"></span>',
        isValueOne = false;

    $('.filter-list').eq(0).addClass('active')

    $(document).on('change','.quantityInput', function (e) {
        e.preventDefault();
        var $this = $(this),
            $page = $this.data("form");
        $target = ($page === 'category' || $page === 'checkout') ? $this.parents('.cart-content-box') : $this.parents('.basket-single-product');

        var $qty = $this.val(),
            $qtyInputName = $this.attr("name"),
            $lineItemId = $target.find('input[name="lineItemId"]').val(),
            $currentQtyName = $target.find('[data-id="currentQty"]').attr("name"),
            $currentQty = $target.find('input[name="' + $currentQtyName + '"]').val(),
            $image = $target.find(".img-fluid").attr("src"),
            $dataString = {};
        if ($qty < 1) {
            $target.find('.deleteProductFromCart').click();
            return;
        }
        $this.addClass('d-none')
        $target.find('.spinner-border').removeClass('d-none')
        $dataString[$qtyInputName] = $qty
        $dataString[$currentQtyName] = $currentQty
        ajaxCall($dataString, $image, $lineItemId, $currentQty, $this, $page)
    })

    $(document).on('click', '.qtyControls', function(e){
        var $this = $(this),
            $page = $this.data("id");
        $target = ($page === 'category' || $page === 'checkout') ? $this.parents('.cart-content-box') : $this.parents('.basket-single-product');
        var $amount = $target.find('[data-id="quantity"]'),
            $btn = $this.html(),
            value = $amount.val();

        $this.prop('disabled', true)
        if ($this.hasClass("btn-minus")) {
            value--;
            if (value < 1) {
                isValueOne = true;
                $amount.val(value);
                $target.find('.deleteProductFromCart').click();
                return;
            }
        } else {
            value++;
        }

        $amount.val(value);
        $this.html($loader);

        var $lineItemId = $target.find('input[name="lineItemId"]').val(),
            $qtyInputName = $amount.attr("name"),
            $currentQtyName = $target.find('[data-id="currentQty"]').attr("name"),
            $qty = $target.find('input[name="'+$qtyInputName+'"]').val(),
            $image = $target.find(".img-fluid").attr("src"),
            $currentQty = $target.find('input[name="'+$currentQtyName+'"]').val(),
            $dataString={};

        $dataString[$qtyInputName] = $qty
        $dataString[$currentQtyName] = $currentQty
        ajaxCall($dataString, $image, $lineItemId, $currentQty, $this, $page, $btn)
    })

    function ajaxCall($dataString, $image, $lineItemId, $currentQty, $this, $page, $btn) {
        $.ajax({
            type: "POST",
            dataType: "json",
            url: "/actions/commerce/cart/update-cart",
            headers: {
                "X-CSRF-Token": window.csrfTokenValue,
            },
            data: $dataString,
        }).done(function (data) {
            console.log(data)
            var totalQty = 0
            if (data.cart) {
                var currency = data.cart.paymentCurrency === 'EUR' ? '€' : 'US$';
                updateCart(data, currency, $page)
                var purchasableId = 0;
                $.each(data.cart.lineItems, function (key, lineItem) {

                    if (lineItem.id == $lineItemId) {
                        purchasableId = lineItem.purchasableId
                        var subTotal = currency + '' + Number(lineItem.total).toFixed(2),
                            itemTitle = lineItem.snapshot.product ? lineItem.snapshot.product.title : lineItem.snapshot.event.title;

                        if (lineItem.total === 0) {
                            subTotal = "FREE";
                        }
                        totalQty = lineItem.qty
                        $('.cart-menu-popup').removeClass('d-none')
                        $('.product-selected-details').html(
                            '<p>' + itemTitle + '</p>' +
                            '<label for="">' + lineItem.description + '</label>' +
                            '<ul>' +
                            '<li>' + currency + (Number(lineItem.salePrice).toFixed(2)) + '</li>' +
                            '<li>Qty:1</li>' +
                            '</ul>'
                        )
                        $('.product-selected-image').html(
                            '<img  src="' + $image + '" alt="">'
                        )

                        $target.find('.individualTotalPrice').html(subTotal)
                    }
                });
                var qtyDivLength = $('.related-item-box').find('[data-id="count-' + purchasableId + '"]');
                qtyDivLength.text(totalQty).removeClass('bit').addClass('bit');

                if ($currentQty < totalQty) {
                    setTimeout(() => {
                        $('.cart-menu-popup').removeClass('bit').addClass('bit');
                        setTimeout(() => {
                            $('.cart-menu-popup').removeClass('bit').addClass('d-none');
                            $('.related-item-box').find('[data-id="count-' + purchasableId + '"]').removeClass('bit');
                        }, 4000);
                    }, 1000);
                } else {
                    setTimeout(() => {
                        $('.related-item-box').find('[data-id="count-' + purchasableId + '"]').removeClass('bit');
                    }, 3000);
                }
                $this.prop('disabled', false)
                $this.removeClass('d-none')
                $target.find('.spinner-border').addClass('d-none')
                $this.html($btn);
            }
        });
    }

    $(document).on('click', '.deleteProductFromCart', function(e){
        e.preventDefault();
        var $page = $(this).data("name");
        $target = ($page === 'category' || $page === 'checkout') ? $(this).parents('.cart-content-box') : $(this).parents('.basket-single-product');
        var $lineItemId = $(this).data('val'),
            $purchasableId = $(this).data('id'),
            $removeProductId = 'lineItems[' + $lineItemId + '][remove]',
            $dataString = {};
        isValueOne ? $target.find('.btn-minus').html($loader) : $(this).html($loader);
        isValueOne = false;
        $dataString[$removeProductId] = 1
        $.ajax({
            type: "POST",
            dataType: "json",
            url: "/actions/commerce/cart/update-cart",
            headers: {
                "X-CSRF-Token": window.csrfTokenValue,
            },
            data: $dataString,
        }).done(function (data) {
            if (data.cart) {
                var currency = data.cart.paymentCurrency === 'EUR' ? '€' : 'US$';
                updateCart(data, currency, $page)
                if (data.cart.totalQty === 0) {
                    $('.top-checkout-section').addClass('d-none')
                    $('.product-list-category').addClass('cart-section')
                    $('.basket-items').html('<p class="p-3">Your basket is empty</p>');
                    if ($page == 'checkout') {
                        $('.storeBtn').removeClass('d-none')
                        $('.voucher-card').remove()
                        $('.tax-discount').remove()
                        $('.basket-items').html('<p  class="p-3 text-center">Your basket is empty</p>');
                    }
                }
                $target.remove();
                $('[data-id="count-' + $purchasableId + '"]').remove();
            }
        });
    });

    function updateCart(data, currency, page) {
        var totalPrice = currency + Number(data.cart.total).toFixed(2)
        $('.cartQty').text('(' + data.cart.totalQty + ' Items)');
        $('.totalCartPrice').html(totalPrice);
        page === 'category' || page === 'checkout' ? $headerBasket.data("basket-updated", true) : $cartUpdate.data("cart-updated", true);

        $headerBasket.attr("data-qty", data.cart.totalQty);
        if (page == 'checkout'){
            $.ajax({
                type: "POST",
                dataType: "json",
                url: "/actions/client/client/cart-update-ajax",
                headers: {
                    "X-CSRF-Token": window.csrfTokenValue,
                },
            }).done(function (data) {
                console.log("basket replace");
                var taxDiscount = $(data.taxDiscount).find('.summary')
                $('.tax-discount').html(taxDiscount);
            });
        }
        if (data.cart.totalQty > 9) {
            $headerBasket.addClass("double-digits");
        } else if ($headerBasket.hasClass("double-digits")) {
            $headerBasket.removeClass("double-digits");
        }
    }

    $('.tab-btn').click(function () {
        $('.filter-list').removeClass('active');
        $(this).addClass('active');

        let _tab_index = $(this).data('index');
        let _sticky_category_height = $('.sticky-top').height();
        let _sticky_cart_height = $('#sticky').height();

        let decrease_extra_height = 0;
        if ($('.product-list-category').find('.sticky').length > 0) {
            decrease_extra_height = parseInt($('.product-list-category').find('.sticky').height()) - 40
            if ($(window).innerWidth() > 768) {
                decrease_extra_height = parseInt($('.product-list-category').find('.sticky').height()) + 40
            }
        } else {
            decrease_extra_height = 20
            if ($(window).innerWidth() > 768) {
                decrease_extra_height = 170;
            }
        }

        $('html, body').animate({
            scrollTop: parseInt($(".tab" + _tab_index).offset().top) - parseInt(decrease_extra_height) - parseInt(_sticky_category_height) - parseInt(_sticky_cart_height)
        }, 500);

    });

    $(window).scroll(sticky_relocate);
    sticky_relocate();

    function sticky_relocate() {
        var window_top = $(window).scrollTop();
        if ($('#sticky-anchor').length > 0) {
            var div_top = $('#sticky-anchor').offset().top;
            $('.filter-list').each(function () {
                var currentLink = $(this).data('index')
                var refLink = $('.tab' + currentLink)
                if (refLink.position().top <= window_top && refLink.position().top + refLink.height() > window_top) {
                    $('.filter-list').removeClass('active');
                    $(this).addClass("active");
                }
            })
            if (window_top > div_top) {
                $('#sticky').addClass('sticky');
                $('.product-list-category').addClass('sticky');
            } else {
                $('#sticky').removeClass('sticky');
                $('.product-list-category').removeClass('sticky');
            }
        }
    }
}
export default func;